import React, { useState } from "react";
import { Button, Box, Typography } from "@mui/material";
import HeaderBannerPage from "../components/HeaderBannerPage";
import SupervisorWiseOT from "../components/tables/SupervisorWiseOT";
// import NonAllocatedEmp from "../components/tables/NonAllocatedEmp"; // OT Non Allocated — replaced by Leave Not Approved (file kept)
import NotApprovedLeave from "../components/tables/Notapprovedleave";
import LocationBasedEmp from "../components/tables/LocationBasedEmp";
import EmpAllocation from "../components/tables/EmpAllocation";
import EmpDiscripency from "../components/tables/EmpDiscripency";
import EWODiscripency from "../components/tables/EWODiscripency";
import AttendanceAdmin from "../components/tables/AttendanceAdmin";
import AbsentEmployee from "../components/tables/AbsentEmployee";
import DesignationBased from "../components/tables/DesignationBasedEmp";

const OTTableViews = () => {
  const [action, setAction] = useState("location");

  const handleAction = (selectedAction) => {
    setAction(selectedAction);
  };

  const buttons = [
    { label: "Employee Attendance", color: "#142C54", action: "location" },
    { label: "Employee Allocation", color: "#B71C1C", action: "Allocation" },
    { label: "OT Allocated", color: "#77652aff", action: "supervisor" },
    // { label: "OT Non Allocated", color: "#b87a15ff", action: "nonAllocated" },
    { label: "Leave Approval", color: "#b87a15ff", action: "notApprovedLeave" },
    { label: "Allocation Discripency", color: "#868522ff", action: "EmpDiscripency" },
    { label: "Attendance Admin", color: "rgb(33, 146, 190)", action: "AttendanceAdmin" },
    { label: "EWO Discripency", color: "#2E8B57", action: "EWODiscripency" },
     { label: "Designation Based", color: "rgb(33, 146, 190)", action: "DesignationBased" },
  ];

  const renderActionButtons = () => {
    const topFourButtons = buttons.slice(0, 4);
    const bottomButtons = buttons.slice(4);

    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          // mt: 0.25,
          px: 1,
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        {/* First Row - 4 Buttons */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: 1.5,
            width: "100%",
          }}
        >
          {topFourButtons.map((btn) => (
            <Button
              key={btn.action}
              variant="contained"
              onClick={() => handleAction(btn.action)}
              sx={{
                padding: "12px 8px",
                fontSize: "11px",
                fontWeight: "600",
                backgroundColor:
                  action === btn.action ? btn.color : "#878787ff",
                color: "#FFFFFF",
                borderRadius: "6px",
                textTransform: "none",
                transition: "all 0.3s ease",
                border: action === btn.action ? `2px solid ${btn.color}` : "2px solid #878787ff",
                minHeight: "60px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                whiteSpace: "normal",
                lineHeight: "1.2",
                "&:hover": {
                  backgroundColor: btn.color,
                  transform: "scale(1.05)",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                },
                "&:active": {
                  transform: "scale(0.98)",
                },
              }}
            >
              {btn.label}
            </Button>
          ))}
        </Box>

        {/* Second Row - 2 Buttons with Same Gap */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: 1.5,
            width: "100%",
          }}
        >
          {bottomButtons.map((btn) => (
            <Button
              key={btn.action}
              variant="contained"
              onClick={() => handleAction(btn.action)}
              sx={{
                padding: "12px 16px",
                fontSize: "12px",
                fontWeight: "600",
                backgroundColor:
                  action === btn.action ? btn.color : "#878787ff",
                color: "#FFFFFF",
                borderRadius: "6px",
                textTransform: "none",
                transition: "all 0.3s ease",
                border: action === btn.action ? `2px solid ${btn.color}` : "2px solid #878787ff",
                minHeight: "52px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                whiteSpace: "normal",
                lineHeight: "1.2",
                "&:hover": {
                  backgroundColor: btn.color,
                  transform: "translateY(-2px)",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                },
                "&:active": {
                  transform: "translateY(0px)",
                },
              }}
            >
              {btn.label}
            </Button>
          ))}
        </Box>
      </Box>
    );
  };

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FFFFFF",
      }}
    >
      <HeaderBannerPage />
      <Box
        sx={{
          padding: "16px",
          fontFamily: "Arial, sans-serif",
          flex: 1,
          overflowY: "auto",
          backgroundColor: "#FFFFFF",
        }}
      >
        {renderActionButtons()}

        {action === "location" && (
          <Box sx={{ mt: 3 }}>
            <LocationBasedEmp />
          </Box>
        )}
        {action === "Allocation" && (
          <Box sx={{ mt: 3 }}>
            <EmpAllocation />
          </Box>
        )}
        {action === "supervisor" && (
          <Box sx={{ mt: 3 }}>
            <SupervisorWiseOT />
          </Box>
        )}
        {/* {action === "nonAllocated" && (
          <Box sx={{ mt: 3 }}>
            <NonAllocatedEmp />
          </Box>
        )} */}
        {action === "notApprovedLeave" && (
          <Box sx={{ mt: 3 }}>
            <NotApprovedLeave />
          </Box>
        )}
        {action === "EmpDiscripency" && (
          <Box sx={{ mt: 3 }}>
            <EmpDiscripency />
          </Box>
        )}
        {action === "AttendanceAdmin" && (
          <Box sx={{ mt: 3 }}>
            <AttendanceAdmin />
          </Box>
        )}
        {action === "EWODiscripency" && (
          <Box sx={{ mt: 3 }}>
            <EWODiscripency />
          </Box>
        )}
        {action === "DesignationBased" && (
          <Box sx={{ mt: 3 }}>
            <DesignationBased />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default OTTableViews;